import React from 'react';
import { Image, List, Segment, Header, Grid, Statistic, Popup, Divider } from 'semantic-ui-react';
import axios from 'axios';
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

export default class Statistics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };

    }

    render() {
        return (
            <div >
                <Header as="h1"></Header>

<br/>
<br/>
                <Grid columns={3} centered className="stackable">
                    <Grid.Row stretched>
                        <Grid.Column>
                            <Segment raised>
                                <Statistic.Group widths="one">
                                    <Statistic color="teal">
                                        <Statistic.Value>3</Statistic.Value>
                                        <Statistic.Label>fakulteta</Statistic.Label>
                                    </Statistic>
                                </Statistic.Group>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column>
                            <Segment raised>
                                <Statistic.Group widths="one">
                                    <Statistic color="blue">
                                        <Statistic.Value>224</Statistic.Value>
                                        <Statistic.Label>Korisnika profesora</Statistic.Label>
                                    </Statistic>
                                </Statistic.Group>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column>
                            <Segment raised>
                                <Statistic.Group widths="one">
                                    <Statistic color="teal">
                                        <Statistic.Value>1184</Statistic.Value>
                                        <Statistic.Label>korisnika studenata</Statistic.Label>
                                    </Statistic>
                                </Statistic.Group>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <br/>
                <br/>

                <Segment raised style={{textAlign:'center'}}>
                    <h2 >Datum prelaska na <span>eUNSA</span> sistem:</h2>
                    <h3 style={{color:'#00b5ad'}}>1. novembar 2018. godine</h3>

                    <Divider/>
                    <br/>

                    <Grid columns={3} centered className="stackable">
                        <Grid.Row stretched>
                            <Grid.Column>
                                <Segment raised>
                                    <Statistic.Group widths="one" size='mini'>
                                        <Statistic color="blue">
                                            <Statistic.Value>Pedagoški fakultet</Statistic.Value>
                                        </Statistic>
                                    </Statistic.Group>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column>
                                <Segment raised>
                                    <Statistic.Group widths="one" size='mini'>
                                        <Statistic color="blue">
                                            <Statistic.Value>Akademija likovnih umjetnosti</Statistic.Value>
                                        </Statistic>
                                    </Statistic.Group>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column>
                                <Segment raised>
                                    <Statistic.Group widths="one" size='mini'>
                                        <Statistic color="blue">
                                            <Statistic.Value>Farmaceutski fakultet</Statistic.Value>
                                        </Statistic>
                                    </Statistic.Group>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <br/>
                </Segment>






            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Dashboard/HomePage.js